// Helpers for the player's flat list of screens (one block per screen).

export const flattenScreens = (modules = []) =>
  modules.flatMap((module, moduleIndex) =>
    (module.screens ?? []).map((block) => ({ block, module, moduleIndex })),
  )

const TYPE_LABELS = {
  courseIntro: 'About this course',
  howToUse: 'How to use this course',
  moduleIntro: 'Module introduction',
  illustration: 'Illustration',
  knowledgeCheck: 'Knowledge check',
}

// The heading shown on a screen, and its name in the outline.
export const screenTitle = (block, module) => {
  if (block.type === 'moduleIntro') return module?.title ?? TYPE_LABELS.moduleIntro
  return block.title ?? TYPE_LABELS[block.type] ?? 'Screen'
}

export const outlineLabel = (block) =>
  block.type === 'moduleIntro' ? TYPE_LABELS.moduleIntro : screenTitle(block)

export const isComplete = (blocks, blockId) => !!blocks?.[blockId]?.completedAt

// Mirrors the server (helpers/training/locks.js): the furthest screen a
// learner can open is the first one they have not completed.
export const firstIncompleteIndex = (screens, blocks) =>
  screens.findIndex(({ block }) => !isComplete(blocks, block.id))

export const canOpen = (screens, blocks, index, locksOff) => {
  if (locksOff) return true
  const frontier = firstIncompleteIndex(screens, blocks)
  return frontier === -1 || index <= frontier
}

// Where to open the course: the screen the learner was last on if they can
// still reach it, otherwise the first one they have not finished.
export const resumeIndex = (screens, progress, locksOff) => {
  const blocks = progress?.blocks ?? {}
  const current = screens.findIndex(({ block }) => block.id === progress?.currentBlockId)
  if (current !== -1 && canOpen(screens, blocks, current, locksOff)) return current
  const frontier = firstIncompleteIndex(screens, blocks)
  return frontier === -1 ? Math.max(screens.length - 1, 0) : frontier
}
